import * as React from 'react'
import { useMemo } from 'react'
import BaseFixedPriceOverview, { BaseFixedPriceOverviewProps, FixedPriceFilterType } from './BaseFixedPriceOverview'

export type FileFixedPriceOverviewProps = Partial<BaseFixedPriceOverviewProps> & {
    baseUrl: string
    fileId: string
    localStorageKeyPrefix?: string
}

/**
 * The fixed-price overview within a dossier (HAM-3627 look-and-feel): the fixed prices of the file.
 * All data loading, the filter, the create button and the add/edit popup come from
 * BaseFixedPriceOverview; this wrapper only scopes to the file (hiding the redundant file filter).
 */
export default function FixedPriceOverview(props: FileFixedPriceOverviewProps) {
    const fixedFilterValues = useMemo<Partial<FixedPriceFilterType>>(() => ({ files: props.fileId ? [props.fileId] : undefined }), [props.fileId])

    return <BaseFixedPriceOverview {...props} fixedFilterValues={fixedFilterValues} hideFileField={!!props.fileId} />
}
